// src/context/LanguageContext.js
import React, { createContext, useState } from 'react';

// Erstelle den Kontext
export const LanguageContext = createContext();

// Provider-Komponente, die den globalen Sprachzustand verwaltet
export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        const savedLanguage = localStorage.getItem('language');
        return savedLanguage ? savedLanguage : 'de'; // Standard ist 'de'
    });

    // Speichern der Sprache im localStorage, wenn sie sich ändert
    const changeLanguage = (newLanguage) => {
        setLanguage(newLanguage);
        localStorage.setItem('language', newLanguage);
    };

    return (
        <LanguageContext.Provider value={{ language, changeLanguage }}>
            {children}
        </LanguageContext.Provider>
    );
};
